"use client";

import { useEffect } from "react";

import {
  applyUiScaleToDocument,
  DEFAULT_UI_SCALE,
  isUiScale,
  useUiScaleStore,
} from "../model/ui-scale-store";

export function UiScaleInit() {
  const scale = useUiScaleStore((s) => s.scale);

  useEffect(() => {
    const resolved = isUiScale(scale) ? scale : DEFAULT_UI_SCALE;
    if (!isUiScale(scale)) {
      useUiScaleStore.setState({ scale: DEFAULT_UI_SCALE });
    }
    applyUiScaleToDocument(resolved);
  }, [scale]);

  return null;
}
